var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50001 12.75H2.45801L10.521 4.688L9.56201 3.729L1.50001 11.792V12.75ZM12.458 4.083L10.188 1.792L11.062 0.917C11.2427 0.722333 11.458 0.625 11.708 0.625C11.958 0.625 12.1803 0.722333 12.375 0.917L13.333 1.896C13.5137 2.06267 13.597 2.285 13.583 2.563C13.569 2.84033 13.4787 3.06233 13.312 3.229L12.458 4.083ZM1.31201 13.667C1.11801 13.667 0.948008 13.5973 0.802008 13.458C0.656008 13.3193 0.583008 13.1527 0.583008 12.958V11.667C0.583008 11.5837 0.600341 11.5037 0.635008 11.427C0.670341 11.3503 0.722675 11.2707 0.792008 11.188L9.56201 2.417L11.833 4.688L3.06201 13.458C2.99267 13.5413 2.92001 13.597 2.84401 13.625C2.76734 13.653 2.68034 13.667 2.58301 13.667H1.31201ZM10.042 4.208L9.56201 3.729L10.521 4.688L10.042 4.208Z",
    stroke: "#004368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit_blue.cdcdf804ab8562ef719736c488e9b11b.svg";
export { ForwardRef as ReactComponent };